import EFPicture from 'elem/compCommon/EFPicture';
import { Collapse } from 'antd';
import { useMemo } from 'react';
import People from 'elem/SVGIcon/PowerBackup/People';
import Store from 'elem/SVGIcon/PowerBackup/Store';
import Chat from 'elem/SVGIcon/PowerBackup/Chat';
import LFP from 'elem/SVGIcon/PowerBackup/LFP';
import GaN from 'elem/SVGIcon/PowerIndependence/GaN';
import BigPhone from '@elem/SVGIcon/PowerBackup/BigPhone';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function L() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('powerindependence');
    const [active, setActive] = useState(0);
    const lists: any = [
        {
            title: t('secL_list1_title'),
            desc: t('secL_list1_desc'),
            icons: [
                {
                    icon: <People />,
                    text: t('secL_list1_icon1'),
                },
                {
                    icon: <Store />,
                    text: t('secL_list1_icon2'),
                },
                {
                    icon: <Chat />,
                    text: t('secL_list1_icon3'),
                },
            ],
        },
        {
            title: t('secL_list2_title'),
            desc: t('secL_list2_desc'),
            icons: [
                {
                    icon: <LFP className="original" />,
                    text: t('secL_list2_icon1'),
                },
                {
                    icon: <GaN className="original h5" />,
                    text: t('secL_list2_icon2'),
                },
            ],
        },
        {
            title: t('secL_list3_title'),
            desc: t('secL_list3_desc'),
            icons: [
                {
                    icon: <BigPhone className="color" />,
                    text: t('secL_list3_icon1'),
                },
            ],
        },
    ];

    const renderImg = useMemo(
        () => (
            <EFPicture
                src={`/responsive/picture/power-independence/12_${Number(active || 0) + 1}.jpg`}
                srcPad={`/responsive/picture/power-independence/12_${Number(active || 0) + 1}_375.jpg`}
                srcMobile={`/responsive/picture/power-independence/12_${Number(active || 0) + 1}_375.jpg`}
                alt={t('secL_title')}
            />
        ),
        [active],
    );

    return (
        <div id="power-independence-L" className={`power-independence-L ${css['power-independence-L']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secL_title')}</p>
                </div>
                <div className="box-container">
                    <div className="card-box">
                        <div className="card-inner">
                            <Collapse
                                ghost={true}
                                className="collapse-lists"
                                defaultActiveKey={0}
                                onChange={setActive}
                                accordion={true}
                                expandIcon={({ isActive }: any) => {
                                    return (
                                        !isActive && (
                                            <svg
                                                className="collapse-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="25"
                                                height="25"
                                                viewBox="0 0 25 25"
                                                fill="none"
                                            >
                                                <path
                                                    d="M12.5 22.5C18.0228 22.5 22.5 18.0228 22.5 12.5C22.5 6.97715 18.0228 2.5 12.5 2.5C6.97715 2.5 2.5 6.97715 2.5 12.5C2.5 18.0228 6.97715 22.5 12.5 22.5Z"
                                                    stroke="#757575"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.5 11.5L12.5 15.5L16.5 11.5"
                                                    stroke="#757575"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        )
                                    );
                                }}
                                expandIconPosition="right"
                            >
                                {lists?.map((list: any, k: number) => (
                                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                                        <div className="list-img">{renderImg}</div>
                                        <p className="list-desc">{list.desc}</p>
                                        <ul className="list-icons">
                                            {list?.icons?.map((icon: any, m: number) => (
                                                <li
                                                    className={`list-icon ${k === 0 && m === 1 ? 'break' : ''}`}
                                                    key={`${k}_${m}`}
                                                    style={{ width: `${100 / list?.icons?.length}%` }}
                                                >
                                                    <div className="icon-box">{icon?.icon}</div>
                                                    <p className="icon-text">{icon?.text}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </Collapse.Panel>
                                ))}
                            </Collapse>
                        </div>
                    </div>
                    <div className="img-box">{renderImg}</div>
                </div>
            </div>
        </div>
    );
}
